import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import PilotFaqV2 from "../pilot-faq-v2";

const getParsedList = list => (list || []).map(item => ({ ...item, answer: item.answerForMobile }));

const EliteFaq = ({
    section
}) => {

    const { pageSection = {} } = section || {};
    const { sectionData = [] } = pageSection || {};

    return (
        <div styleName={"styles.eliteFaqWrapper"}>
            <PilotFaqV2 list={getParsedList(sectionData)} attachSchema={true} heading={"Frequently asked questions"} />
        </div>
    );
};

EliteFaq.propTypes = {
    section: PropTypes.object
};

export default EliteFaq;
